import api from "./api";

export const BookingService = {
  getAll: async (params = {}) => {
    const { data } = await api.get("/v1/bookings", { params });
    return data;
  },

  getById: async (id) => {
    const { data } = await api.get(`/v1/bookings/${id}`);
    return data;
  },

  create: async (payload) => {
    const { data } = await api.post("/v1/bookings", payload);
    return data;
  },

  cancel: async (id) => {
    const { data } = await api.delete(`/v1/bookings/${id}`);
    return data;
  },

  approve: async (id) => {
    const { data } = await api.post(`/v1/bookings/${id}/approve`);
    return data;
  },

  reject: async (id, reason) => {
    const { data } = await api.post(`/v1/bookings/${id}/reject`, { reason });
    return data;
  },

  checkout: async (id, payload) => {
    const { data } = await api.post(
      `/v1/bookings/${id}/checkout`,
      payload
    );
    return data;
  },

  returnVehicle: async (id, payload) => {
    const { data } = await api.post(
      `/v1/bookings/${id}/return`,
      payload
    );
    return data;
  },
};
